import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  dataExamResult: null,
  examResultPart: [],
  isPauseAudio: true,
  isOpenBadPause: false,
  tabValue: 1,
  tabScrollValue: 'overview',
  audioTime: {},
  audioClips: null,
}

export const examResultSlice = createSlice({
  name: 'examResult',
  initialState,
  reducers: {
    updateDataExamResult: (state, action) => {
      state.dataExamResult = action.payload
    },
    updateExamResultPart: (state, action) => {
      state.examResultPart = action.payload
    },
    updateIsPauseAudio: (state, action) => {
      state.isPauseAudio = action.payload
    },
    updateIsOpenBadPause: (state, action) => {
      state.isOpenBadPause = action.payload
    },
    updateTabValue: (state, action) => {
      state.tabValue = action.payload
    },
    updateTabScrollValue: (state, action) => {
      state.tabScrollValue = action.payload
    },
    updateAudioTime: (state, action) => {
      state.audioTime = action.payload
    },
    updateAudioClips: (state, action) => {
      state.audioClips = action.payload
    },
    reset: () => {
      return initialState
    },
  },
})

export const {
  updateDataExamResult,
  updateExamResultPart,
  updateIsPauseAudio,
  updateIsOpenBadPause,
  updateTabValue,
  updateTabScrollValue,
  updateAudioTime,
  updateAudioClips,
  reset,
} = examResultSlice.actions

export default examResultSlice.reducer
